export default "__VITE_ASSET__BdU7uh3A__"